import React, { useCallback } from 'react';
import { LFC } from '../../../Legacy';
import { ApiClient } from '../../../api/ApiClient';
import { Button } from '../../../ui';
import { AppEvents } from '../../AppEvents';
import { useResolve } from '../../Container';
import { MetricsHub } from '../../MetricsHub';
import { ProfileModel } from '../../ProfileModel';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { PopupManager } from '../../popups/PopupManager';
import { isItXmas } from './WithXmas';

export const XmasTrigger = () => {

    const api = useResolve(ApiClient);
    const me = useResolve(ProfileModel);
    const metrics = useResolve(MetricsHub);
    const popups = useResolve(PopupManager);
    const events = useResolve(AppEvents);

    if (!isItXmas()) return null;
    if (metrics.check('xmas2022')) return null;
    if (me.id.startsWith('US000000')) return null;

    const auto = me.id.startsWith('GU');

    // useEffectOnce(() => {
    //     (async () => {

    //         if (!auto) {
    //             await waitFor(1000);
    //             await popups.invoke({ ui: Xmas });
    //         }

    //         await api.execs(v2.me.preferences.update({ scrooge2022: false }));
    //         events.push('preferences:update', { preferences: { scrooge2022: false } });

    //     })();
    // });

    return null;
};

const Xmas: LFC<PopupProps> = ({ action }) => {

    const metrics = useResolve(MetricsHub);
    const onClick = useCallback(() => {
        metrics.set('xmas2022', 1);
        action(true);
    }, [action]);

    return <Popup w={42}>
        <Popup.Title style={{ textAlign: 'center' }}>Christmas Update 2022</Popup.Title>
        <Popup.Content>
            <Copy>
                Hi everyone,
            </Copy>
            <Copy>
                We are a little late with the festive decorations this year... they depended on
                the Anonymous Mode update which wasn&apos;t ready until this week.  Better late
                than never though!  As usual you can opt out by enabling Scrooge Mode in your user
                settings area.  The Ludi team wish you all a Merry Christmas and hope you all
                have a relaxing and positive break!  Best wishes &amp; see you in 2023!
            </Copy>
            <Copy>
                Steve &amp; Jamie
            </Copy>
        </Popup.Content>
        <Flexer flex="row" center gap="1" margin="1 0 0 0">
            <Button variant="primary" onAction={onClick}>Turn On The Lights!</Button>
        </Flexer>
    </Popup>;
};


